import type { FC, PropsWithChildren } from 'react';
import React, { Suspense, lazy } from 'react';

import type { LivePersonaCardProps } from './LivePersonaCard';

const LivePersonaCard = lazy(
  () => import(/* webpackChunkName: "4-feat-live-persona-card" */ './LivePersonaCardErrorBoundary')
);

const LoadableLivePersonaCard: FC<PropsWithChildren<LivePersonaCardProps>> = (props) => (
  <Suspense fallback={<>{props.children}</>}>
    <LivePersonaCard {...props} />
  </Suspense>
);

export default LoadableLivePersonaCard;
